(ns dre.pages.dictionary.util
  (:require
   [clojure.set :as set]
   [clojure.string :as str]
   [dre.coll :refer [provide-coll]]
   [dre.components.list :refer [collapsable-list]]
   [dre.page-util :refer [strip-lang enum]]))

(def definition (keyword "http://www.w3.org/2004/02/skos/core#definition"))

(def random-str
  (apply str (repeatedly 20 #(rand-nth "abcdefghijklmnopqrstuvwxyz0123456789"))))

(defn select-keys-ordered
  [amap keyseq]
  (let [valid? (set keyseq)]
    (apply array-map (reduce-kv
                      (fn [acc k v]
                        (cond-> acc (valid? k) (conj k v)))
                      []
                      amap))))

(defn items-map
  [props keymap]
  (let [col-keys  ;; keys that exist in at least one row
        (->> props (map (comp set keys)) (apply set/union))]
    (select-keys-ordered keymap col-keys)))

(def no-item
  [:div.no-item "—"])

(defn bool-item
  [item]
  [:div.bool-item
   {:class (if item "bool-item-true" "bool-item-false")}
   (if item "✓" "✕")])

(defn str-item
  [item]
  (str item))

(defn array-item
  [item]
  (str/join ", " item))

(defn object-item
  [{:keys [name title]}]
  (or name title))

(defn list-item
  [coll]
  [collapsable-list
   (mapv (fn [obj]
           {:content obj}) (sort (map object-item coll)))
   3])

(defn list-item-simple
  [coll]
  [collapsable-list
   (mapv (fn [obj]
           {:content obj}) coll)
   3])

(defn age-item
  [{:keys [amount unit]}]
  (str amount " " unit
       (when (> amount 1) "s")))

(defn table-data
  [item-fn key item row]
  {key
   (cond
     (nil? item) no-item
     (and (coll? item) (empty? item)) no-item
     :else [item-fn item row])})

(defn table-row
  [items row]
  (map (fn [[k [_ item-fn]]]
         (table-data item-fn k (k row) row))
       (seq items)))

(defn table-head-row
  [items-map]
  (map (fn [[f s]]
         {:key f :label (first s)}) items-map))

(defn table-content-rows
  [items-map props]
  (map #(into {} %) (map (partial table-row items-map) props)))

;;;;;;;;;;;;;;; 

(defn alt-labels
  [doc]
  (mapcat strip-lang (provide-coll (get doc :term/alts))))

(defn rename-vocabs
  [vocab]
  (get {"taxonomy" "GHDX"} vocab vocab))

(defn extract-term-from-url
  "Return the name of the last term from an input URL string."
  [url-str]
  (when url-str
    (let [url-str (if (and (= (last url-str) \/) (< 1 (count url-str)))
                    (subs url-str 0 (dec (count url-str)))
                    url-str)
          vocab
          (re-find #"(?!.*#).+"
                   (re-find #"(?!.*/).+" url-str))]
      vocab)))

(defn term-vocabulary
  [term]
  (rename-vocabs (extract-term-from-url (get term :vocab/uri))))

(defn term-definition
  [term]
  (let [definitions (mapcat
                     strip-lang
                     (provide-coll (get term definition)))]
    (when (seq definitions)
      [(term-vocabulary term) (apply str definitions)])))
